/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import customStyles from "../../../../assets/styles/customStyles";
import clsx from "clsx";
import ImportIcon from "../../../../assets/images/icon_actions/Import.svg";
import { useDispatch, useSelector } from "react-redux";
import uploadActions from "../../../Upload/redux/actions";
import { v4 as uuidv4 } from 'uuid';
import { getUploadedFile } from "../../../../helpers/utilities";

export default function FileUpload(props) {
    const { uploadData, uploadLoader } = useSelector(state => state.uploadReducer);
    const { handleChange, text, maxSize, types, loader, id = "imageUpload", filePath, path, view, alt, square, deleteIcon } = props;
    const [values, setValues] = useState({});
    const [error, setError] = useState('');
    const [activeId, setActiveId] = useState('');
    const dispatch = useDispatch();

    const handleDrop = (e) => {
        e.preventDefault();
        const file = e.dataTransfer.files[0];
        if (validateFile(file)) {
            dispatchFile(file);
            setError('');
        }
    };

    const dispatchFile = (file) => {
        var formData = new FormData();
        formData.append("file", file);
        formData.append("fileUri", `${path}${uuidv4()}.${file?.name.split('.').pop()}`);
        dispatch({
            type: uploadActions.UPLOAD_START,
            title: 'Product Image',
            details: formData
        });
    }

    const validateFile = (file) => {
        const allowedTypes = types ? types.split(",") : ['image/jpeg', 'image/png', 'image/gif'];
        const maxSizeMB = maxSize || 1;

        if (!allowedTypes.includes(file.type)) {
            setError('File type not supported. Please upload an image.');
            return false;
        }

        if (file.size > maxSizeMB * 1024 * 1024) {
            setError(`File size exceeds ${maxSizeMB}MB. Please upload a smaller file.`);
            return false;
        }

        return true;
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleFileInputChange = (e) => {
        if (id) {
            setActiveId(id);
        }
        const file = e.target.files[0];
        if (validateFile(file)) {
            if (square && file) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    const img = new Image();
                    img.onload = () => {
                        if (img.width !== img.height) {
                            setError(`Please upload `);
                            return false;
                        } else {
                            setValues({
                                file: file,
                                preview: URL.createObjectURL(file)
                            });
                            dispatchFile(file);
                            setError('');
                        }
                    };
                    img.src = e.target.result;

                };
                reader.readAsDataURL(file);
            } else {
                setValues({
                    file: file,
                    preview: URL.createObjectURL(file)
                });
                dispatchFile(file);
                setError('');
            }
        }
    };


    useEffect(() => {
        if (filePath) {
            setValues({
                preview: filePath
            });
        }
        return () => {
            dispatch({
                type: uploadActions.CLEAR_UPLOAD_START,
            });
        };
    }, [filePath]);

    useEffect(() => {
        if (activeId === id && uploadData && uploadData !== '') {
            handleChange(uploadData);
            setActiveId('');
        }
    }, [uploadData]);

    const classes = customStyles();

    return (
        <>
            {
                view ? <div className={clsx(classes.productImageUploadInner, classes.productImageUploadInnerView)}>
                    <div className={classes.imageContainer}>
                        {
                            values?.preview ?
                                <img src={getUploadedFile(values?.preview)} alt={alt || "logo"} className={classes.previewImg} /> : 'No images uploaded'
                        }
                    </div>
                </div> : <div className={clsx(classes.productImageUploadInner, { [classes.loading]: loader })}
                    onDrop={(e) => handleDrop(e)}
                    onDragOver={(e) => handleDragOver(e)}>
                    {
                        activeId === id && uploadLoader ? <div className={classes.textAlignCenter}>
                            <div className={classes.loadMoreCircle}></div>
                        </div> : <>
                            {
                                values?.preview &&
                                <div className={classes.imageContainer}>
                                    <img
                                        src={getUploadedFile(values?.preview)}
                                        className={classes.previewImg}
                                        alt="preview"
                                    />
                                </div>
                            }
                        </>
                    }
                    <div className={classes.imageContainerText}>
                        <p className={clsx(classes.textAreaLableColorUpload)}>Drag and Drop</p>
                        <p className={clsx(classes.textAreaLableColorUpload)}>or</p>
                        <input
                            type="file"
                            id={id}
                            onChange={(e) => handleFileInputChange(e)}
                            style={{ display: 'none' }}
                        />
                        <label htmlFor={id} className={clsx(classes.textAreaLableColorUpload, classes.textAlignCenter, { [classes.deletedIcon]: deleteIcon })}>
                            <p className={classes.importImage}><img
                                src={ImportIcon}
                                className={clsx(classes.antImage)}
                                alt="import"
                            /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Import</span></p>
                            {text}
                        </label>
                        {error && <p style={{ color: 'red' }}>{error}</p>}
                    </div>

                </div>
            }
        </>
    )
}